module.exports = __webpack_public_path__ + "img/9788954430005.3c2bd2cf.jpg";